export default {
    id: "2a41e44b-3203-46ba-919f-4ca9490d0106",
    icon: "mdi-video",
    name: "video",
    title: "Video",
    description: "A block Video",
}